var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radix-icons:cross-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2785 9.67656C28.4068 9.54845 28.5086 9.39632 28.5781 9.22886C28.6475 9.06141 28.6834 8.88191 28.6835 8.70061C28.6836 8.51931 28.648 8.33977 28.5787 8.17223C28.5094 8.00469 28.4078 7.85244 28.2797 7.72416C28.1516 7.59589 27.9995 7.4941 27.832 7.42462C27.6646 7.35514 27.4851 7.31932 27.3038 7.31921C27.1225 7.3191 26.9429 7.3547 26.7754 7.42397C26.6078 7.49325 26.4556 7.59485 26.3273 7.72296L18.0017 16.0486L9.67852 7.72296C9.41945 7.4639 9.06809 7.31836 8.70172 7.31836C8.33535 7.31836 7.98398 7.4639 7.72492 7.72296C7.46585 7.98203 7.32031 8.33339 7.32031 8.69976C7.32031 9.06613 7.46585 9.4175 7.72492 9.67656L16.0505 17.9998L7.72492 26.323C7.59664 26.4512 7.49489 26.6035 7.42547 26.7711C7.35604 26.9387 7.32031 27.1184 7.32031 27.2998C7.32031 27.4812 7.35604 27.6608 7.42547 27.8284C7.49489 27.996 7.59664 28.1483 7.72492 28.2766C7.98398 28.5356 8.33535 28.6812 8.70172 28.6812C8.88312 28.6812 9.06276 28.6454 9.23036 28.576C9.39796 28.5066 9.55024 28.4048 9.67852 28.2766L18.0017 19.951L26.3273 28.2766C26.5864 28.5353 26.9376 28.6805 27.3038 28.6803C27.6699 28.6801 28.021 28.5344 28.2797 28.2754C28.5385 28.0163 28.6837 27.6651 28.6835 27.2989C28.6832 26.9328 28.5376 26.5817 28.2785 26.323L19.9529 17.9998L28.2785 9.67656Z",
    fill: "#CF300E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionCancel);
export default __webpack_public_path__ + "static/media/transaction_cancel.db50b9e900b054bef37e63cd7dd2b9fa.svg";
export { ForwardRef as ReactComponent };